import React from 'react';
import { KpiGrid, type KpiItem } from '@/components/ui/KpiGrid';
import { FileCheck, Clock, CheckCircle2, XCircle, AlertTriangle, Timer } from 'lucide-react';

export function ApprovalsKpiDashboard() {
  const kpis: KpiItem[] = [
    {
      title: 'Tổng Yêu Cầu',
      value: 450,
      suffix: 'Phiếu',
      icon: FileCheck,
      color: 'text-indigo-600',
      bg: 'bg-indigo-50',
      trend: 'up',
      trendValue: 'Tháng này',
      chartColor: 'bg-indigo-500',
      chartData: [420, 430, 410, 440, 435, 445, 450]
    },
    {
      title: 'Chờ Bạn Duyệt',
      value: 8,
      suffix: 'Phiếu',
      icon: Clock,
      color: 'text-amber-600',
      bg: 'bg-amber-50',
      trend: 'down',
      trendValue: 'Đã xử lý 3',
      chartColor: 'bg-amber-500',
      chartData: [15, 12, 10, 14, 10, 9, 8]
    },
    {
      title: 'Đã Phê Duyệt',
      value: 385,
      suffix: 'Phiếu',
      icon: CheckCircle2,
      color: 'text-emerald-600',
      bg: 'bg-emerald-50',
      trend: 'up',
      trendValue: 'Hoàn thành',
      chartColor: 'bg-emerald-500',
      chartData: [350, 360, 365, 370, 375, 380, 385]
    },
    {
      title: 'Bị Từ Chối',
      value: 42,
      suffix: 'Phiếu',
      icon: XCircle,
      color: 'text-red-600',
      bg: 'bg-red-50',
      trend: 'down',
      trendValue: 'Đã giảm',
      chartColor: 'bg-red-500',
      chartData: [50, 48, 45, 46, 44, 43, 42]
    },
    {
      title: 'Quá Hạn Xử Lý',
      value: 15,
      suffix: 'Phiếu',
      icon: AlertTriangle,
      color: 'text-rose-600',
      bg: 'bg-rose-50',
      trend: 'up',
      trendValue: 'Cần đốc thúc',
      chartColor: 'bg-rose-500',
      chartData: [10, 11, 10, 12, 13, 14, 15]
    },
    {
      title: 'Tốc Độ Xử Lý',
      value: '4.5',
      suffix: 'Giờ',
      icon: Timer,
      color: 'text-blue-600',
      bg: 'bg-blue-50',
      trend: 'down',
      trendValue: 'Nhanh hơn',
      chartColor: 'bg-blue-500',
      chartData: [5.2, 5.0, 4.8, 4.9, 4.7, 4.6, 4.5]
    }
  ];

  return <KpiGrid kpis={kpis} />;
}
